import { render } from "./OnBoarding.vue?vue&type=template&id=fc350cd6&scoped=true"
import script from "./OnBoarding.vue?vue&type=script&lang=js"
export * from "./OnBoarding.vue?vue&type=script&lang=js"

import "./OnBoarding.vue?vue&type=style&index=0&id=fc350cd6&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc350cd6"]])

export default __exports__